import { render, staticRenderFns } from "./GoogleAdWords.vue?vue&type=template&id=feb0ae2c&"
import script from "./GoogleAdWords.vue?vue&type=script&lang=js&"
export * from "./GoogleAdWords.vue?vue&type=script&lang=js&"
import style0 from "./GoogleAdWords.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports